
import VButton from '~/components/ui/VButton'
import { mapGetters, mapActions, mapState } from 'vuex'
import DynamicTextModal from '~/components/modals/DynamicTextModal'

export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
        buttons: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        ...mapGetters('profile', [
            'role'
        ]),
        ...mapState('booking', [
            'bookingData'
        ])
    },
    methods: {
        ...mapActions('booking', [
            'bookingPay',
            'bookingPaySystem'
        ]),
        pay() {
            this.bookingPay(this.item).then(res => {
                this.$modal.hide('coworking-booking')
                this.bookingPaySystem(res.data)
                // this.$modal.hide('coworking-booking')
                // this.$modal.show(
                //     DynamicTextModal,
                //     {
                //         title: res.data.item.code, 
                //         text: this.$t('booking.yourBookingNumber'),
                //         // body: `
                //         //     Valid until <span style="color: #D84D3E">12:00</span> p.m. <span style="color: #D84D3E">April 25</span>.<br>
                //         //     You can pay for your reservation at the reception.
                //         // `
                //     }, {
                //         maxWidth: 480,
                //         adaptive: true,
                //         clickToClose: false,
                //         height: 'auto',
                //         name: 'dynamic-text-modal',
                //     },
                //     { 'before-close': () => {
                        
                //     } }
                // )
            })
        }
    },
    components: {
        VButton
    }
}
